import React from 'react';


const ArchivedPlanner = (props) => {
    const { allPlanners, onchangePlanner, selectedPlannerId } = props;
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    return (<div className="archivedPlanner pt-3">
        <div className="row">
            {allPlanners && allPlanners.map((item, index) =>
                <div className="col-md-12" key={index} onClick={() => onchangePlanner(item.planner_id)}>
                    <div className={selectedPlannerId === item.planner_id ? "plannerCardSelected" : "plannerCard"}>
                        <div>
                            <div className="row">
                                <div className="col-md-6 d-flex">
                                    <i className="fas fas fa-file-alt fa-2x mb-3"></i>
                                    <h5 className="ml-2">Planner</h5>
                                </div>
                                <div className="col-md-6 text-right">
                                    <i className="fas fa-calendar-check"></i>
                                    <label className="ml-2"> {item.month} , {item.year}</label>
                                </div>
                            </div>
                            {/* <p>{typeof tutorData !== "null" && tutorData?.user?.user_name} has created the planner for  <strong>{JSON.parse(item?.week_data)?.[0]?.["programName"]}</strong> for <strong>{item?.month}</strong>.</p> */}
                            <p>
                                {typeof tutorData !== "null" && tutorData?.user?.user_name} has created the planner for  <strong>
                                    {(() => {
                                        let safeWeekData = item?.week_data ? item.week_data.trim() : "[]";
                                        try {
                                            let parsedWeekData = JSON.parse(safeWeekData);
                                            return <>{parsedWeekData?.[0]?.programName || "Unknown"}</>
                                        } catch (error) {
                                            console.error("Error parsing week_data:", error);
                                            return <>Error loading program data</>;
                                        }
                                    })()}
                                    </strong> for <strong>{item?.month}</strong>.                     
                            </p>
                            {/* <hr /> */}
                            {/* <div className="d-flex">
                                <div className="m-2">
                                    <i className="fas fa-calendar-check"></i>
                                    <label className="ml-2">{item.month} , {item.year}</label>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                // <div className="col-md-6" key={index} onClick={() => onchangePlanner(item.planner_id)}>
                //     <div className={selectedPlannerId === item.planner_id ? "plannerCardSelected" : "plannerCard"}>
                //         <div>
                //             <i className="fas fas fa-file-alt fa-2x mb-3"></i>
                //             <h5>Planner</h5>
                //             <p>{typeof tutorData !== "null" && tutorData.user.user_name} has created the planner for  <strong>{JSON.parse(item.week_data)[0]["programName"]}</strong> for <strong>{item.month}</strong>.</p>
                //             <hr />
                //             <div className="d-flex">
                //                 <div className="m-2">
                //                     <i className="fas fa-calendar-check"></i>
                //                     <label className="ml-2">{item.month} , {item.year}</label>
                //                 </div>
                //             </div>
                //         </div>
                //     </div>
                // </div>
            )}
        </div>
    </div>);
}

export default ArchivedPlanner;